import { Link } from "react-router-dom";

import { CrshmToolMenu, type CrshmToolMenuActive } from "@/components/CrshmToolMenu";

export type CrshmActiveTool = CrshmToolMenuActive;
export type CrshmNavVariant = "light" | "dark";

type Props = {
  active: CrshmActiveTool;
  variant: CrshmNavVariant;
  email?: string | null;
  showAdminLink?: boolean;
};

const topLight = "border-zinc-100 bg-white text-zinc-600";
const topDark = "border-white/10 bg-zinc-950/90 text-zinc-400";

export function CrshmTopBar({ active, variant, email, showAdminLink }: Props) {
  const skin = variant === "light" ? topLight : topDark;
  const brand = variant === "light" ? "text-zinc-900" : "text-white";
  const signedIn = Boolean(email?.trim());

  const bubbleSkin =
    variant === "light"
      ? "border border-zinc-300/90 bg-white/90 text-zinc-900 shadow-sm hover:border-zinc-400 hover:bg-white"
      : "border border-white/25 bg-transparent text-zinc-100 shadow-sm hover:border-white/40 hover:bg-white/[0.06]";

  return (
    <header
      className={`sticky top-0 z-40 overflow-visible border-b ${variant === "dark" ? "backdrop-blur-md" : ""} ${skin} pt-[max(0.5rem,env(safe-area-inset-top))] pb-2`}
    >
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-2 px-4 sm:px-6 lg:px-8">
        <Link to="/" className={`shrink-0 text-sm font-black tracking-tight ${brand}`}>
          crshm
        </Link>
        <div className="flex shrink-0 items-center gap-2">
          <Link
            to={signedIn ? "/dashboard" : "/sign-in"}
            className={`inline-flex min-h-10 items-center justify-center rounded-full px-4 text-sm font-bold transition active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-400 focus-visible:ring-offset-2 ${bubbleSkin}`}
          >
            {signedIn ? "Dashboard" : "Sign in"}
          </Link>
          <CrshmToolMenu active={active} variant={variant} email={email ?? null} showAdminLink={showAdminLink} />
        </div>
      </div>
    </header>
  );
}
